export default __webpack_public_path__ + "static/media/90.e1942851.jpeg";